import { render } from "./ModulesControlTable.vue?vue&type=template&id=89bdf2e6&scoped=true&ts=true"
import script from "./ModulesControlTable.vue?vue&type=script&lang=ts"
export * from "./ModulesControlTable.vue?vue&type=script&lang=ts"

import "./ModulesControlTable.vue?vue&type=style&index=0&id=89bdf2e6&scoped=true&lang=css"

import exportComponent from "/home/helder/SDD_2/Projetos/goldylocks-central-ui-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89bdf2e6"]])

export default __exports__